import React from "react";
import Tile from "./Tile";
import { Row, Col, Container } from "reactstrap";
import "./Examples.css"

const particlesStyle = {
  position: "relative",
  border: "1px white solid",
  borderRadius: "5%",
  marginTop: "5%",
  height: "25vmin",
};

function Examples() {
  return (
    <Container fluid={true} className="Examples">
      <Row className="Examples-row">
        <Col sm="2" />
        <Col sm="2">
          <Tile
            id="tile-1"
            config="configs/tile-1.json"
            style={particlesStyle}
          />
        </Col>
        <Col sm="1" />
        <Col sml="2">
          <Tile
            id="tile-2"
            config="configs/tile-2.json"
            style={particlesStyle}
          />
        </Col>
        <Col sm="1" />
        <Col sm="2">
          <Tile
            id="tile-3"
            config="configs/tile-3.json"
            style={particlesStyle}
          />
        </Col>
        <Col sm="2" />
      </Row>{" "}
      <Row className="Examples-row">
        <Col sm="2" />
        <Col sm="2">
          <Tile
            id="tile-4"
            config="configs/tile-4.json"
            style={{
              ...particlesStyle,
              backgroundImage: `url("http://vincentgarreau.com/particles.js/assets/img/kbLd9vb_new.gif")`,
              backgroundPosition: "50%",
              backgroundSize: "100%",
              backgroundRepeat: "no-repeat"
            }}
          />
        </Col>
        <Col sm="1" />
        <Col sml="2">
          <Tile
            id="tile-5"
            config="configs/tile-5.json"
            style={{
              ...particlesStyle,
              backgroundImage: `url("http://upload.wikimedia.org/wikipedia/commons/thumb/e/e5/NASA_logo.svg/1237px-NASA_logo.svg.png")`,
              backgroundPosition: "50%",
              backgroundSize: "50%",
              backgroundRepeat: "no-repeat"
            }}
          />
        </Col>
        <Col sm="1" />
        <Col sm="2">
          <Tile
            id="tile-6"
            config="configs/tile-6.json"
            style={particlesStyle}
          />
        </Col>
        <Col sm="2" />
      </Row>
    </Container>
  );
}

export default Examples;
